import { useEffect, useState } from 'react';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import * as hospitaisApi from '../../api/hospitais';
import * as conformidadeApi from '../../api/conformidade';
import * as avaliacoesApi from '../../api/avaliacoes';

export default function useDadosPortfolio() {
  const [hospitais, setHospitais] = useState(null);
  const [conformidades, setConformidades] = useState({});
  const [coberturas, setCoberturas] = useState({});
  const [avaliacoesPorHospital, setAvaliacoesPorHospital] = useState({});
  const [historicos, setHistoricos] = useState({});
  const [erro, setErro] = useState('');
  const [erroIndicadores, setErroIndicadores] = useState('');

  const carregar = async () => {
    setErro('');
    let data;
    try {
      const resHospitais = await hospitaisApi.listar();
      data = resHospitais.data;
      setHospitais(data);
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível carregar o dashboard.'));
      return;
    }

    // Conformidade, avaliações e histórico são secundários — se essa parte falhar (ex: backend
    // desatualizado em relação ao banco), o dashboard continua utilizável, só avisamos à parte
    // em vez de deixar tudo silenciosamente em 0% sem nenhum erro visível.
    setErroIndicadores('');
    try {
      // Cada um numa única chamada agregada (todos os hospitais de uma vez) — só o escopo
      // ainda é por hospital, por ora (consulta simples, barata; não é o gargalo). Ver plano de
      // arquitetura da revisão de 2026-07-10.
      const [confResultado, avalResultado, escopoResultados, historicoResultado] = await Promise.all([
        conformidadeApi.obterTodosHospitais({ formula: 'binaria' }),
        avaliacoesApi.listarAtuaisTodosHospitais(),
        Promise.allSettled(data.map((h) => hospitaisApi.obterEscopo(h.id_hospital))),
        conformidadeApi.obterHistoricoTodosHospitais({ formula: 'binaria', meses: 6 }),
      ]);

      const mapaConf = {};
      confResultado.data.forEach((linha) => {
        mapaConf[linha.id_hospital] = linha.percentual;
      });
      setConformidades(mapaConf);

      const mapaAvaliacoes = {};
      data.forEach((h) => {
        mapaAvaliacoes[h.id_hospital] = [];
      });
      avalResultado.data.forEach((a) => {
        if (!mapaAvaliacoes[a.id_hospital]) mapaAvaliacoes[a.id_hospital] = [];
        mapaAvaliacoes[a.id_hospital].push(a);
      });
      setAvaliacoesPorHospital(mapaAvaliacoes);

      const mapaHistorico = {};
      data.forEach((h) => {
        mapaHistorico[h.id_hospital] = [];
      });
      historicoResultado.data.forEach((linha) => {
        if (!mapaHistorico[linha.id_hospital]) mapaHistorico[linha.id_hospital] = [];
        mapaHistorico[linha.id_hospital].push({ mes_referencia: linha.mes_referencia, percentual: linha.percentual });
      });
      setHistoricos(mapaHistorico);

      const mapaCobertura = {};
      data.forEach((h, i) => {
        const escopo = escopoResultados[i].status === 'fulfilled' ? escopoResultados[i].value.data : [];
        mapaCobertura[h.id_hospital] = {
          total: escopo.filter((e) => e.ativo).length,
          avaliados: mapaAvaliacoes[h.id_hospital].length,
        };
      });
      setCoberturas(mapaCobertura);
    } catch (err) {
      setErroIndicadores(extrairMensagemErro(err, 'Não foi possível carregar os indicadores (conformidade, vencimentos, corretivas).'));
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    hospitais,
    conformidades,
    coberturas,
    avaliacoesPorHospital,
    historicos,
    erro,
    erroIndicadores,
    recarregar: carregar,
  };
}
